export var ContractType;
(function (ContractType) {
    ContractType["UniV2Pair"] = "UniV2Pair";
    ContractType["ERC20"] = "ERC20";
    ContractType["ThorRouter"] = "ThorRouter";
})(ContractType || (ContractType = {}));
